<template>
  <b-overlay 
    :show="busy" 
    variant="dark"
  >
    <b-card 
      v-for="(bericht,key) in berichten" 
      :key="key"
      no-body
    >
      <b-card-header>
        <b-card-text class="float-right text-muted text-small">
          {{ bericht.afzender }} op {{ moment(bericht.gemaaktOp).format('LLL') }}
        </b-card-text>
        <router-link 
          :to="bericht.to" 
          class="text-light text-truncate"
        >
          {{ bericht.unit }} {{ bericht.adres }}
        </router-link>
      </b-card-header>
      <b-card-body>
        <span class="font-weight-bold">{{ bericht.onderwerp }}</span>
        {{ bericht.body }}
      </b-card-body>
    </b-card>
  </b-overlay>
</template>
<script>
import { serviceMixin }  from '../../mixins/serviceMixin';
export default {
    name: 'RecenteBerichten',
    components: {},
    mixins: [ serviceMixin],
    props: {
    },
    data() {
        return  {
            berichten: [],
            busy: false,
        }
    },
    computed: {},
    watch: {},
    mounted () {
        this.getBerichten();
    },
    methods: {
        getBerichten() {
            this.busy = true;
            var vm = this;
            this.get('/logboek/recent').then((response) => {
               vm.berichten = response.data.result;
            }).finally(() => {
                vm.busy = false;
            })
        }
    },
          
}
</script>